import '../../css/app.css'
import '../../css/main.css'
import '../../css/common.css'
import '../../css/payment.css'
import Page from '../../Page';
import React from 'react';
import { useState, useEffect, useRef } from 'react';

import { ChevronDown, FileX } from 'lucide-react';

function List({ tableHeaderData, tableBodyData, filter_tableBodyData, page, setPage, maxFirstPage, height, nonePage = true }) {
    let widthRef = useRef()
    const [Width, setWidth] = useState("0")
    const [tableWidth, setTableWidth] = useState("0")
    const [extraWidth, setExtraWidth] = useState(0)
    const [Window, setWindow] = useState(0)

    useEffect(() => {
        const handleResize = () => {
            setWindow(window.innerWidth)
        };

        window.addEventListener('resize', handleResize);
        handleResize()

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    useEffect(() => {
        setWidth(`${widthRef?.current?.offsetWidth}` ?? "100%")
    }, [Window])

    useEffect(() => {
        if (Width != "0" && tableWidth != "0" && !isNaN(Width) && !isNaN(tableWidth)) {
            if (Number(Width) > Number(tableWidth)) {
                setExtraWidth((Number(Width) - Number(tableWidth)) / (tableHeaderData.length))
            }
            else {
                setExtraWidth(0)
            }
        }
    }, [Width, tableWidth])

    return (
        <div className="overflow-x-auto scrollbar-hidden" style={{ width: "100%" }}>
            <div id="tabulator2" className="table-report table-report--tabulator payList tabulator" role="grid" tabulator-layout="fitColumns"
                style={{ width: "100%", height: height ? height : "" }}>
                <div className='tabulator-tableHolder' ref={widthRef}>
                    <Listheader tableHeaderData={tableHeaderData} Width={Width} extraWidth={extraWidth} tableWidth={tableWidth} setTableWidth={setTableWidth} />
                    <Listbody filter_tableBodyData={filter_tableBodyData} extraWidth={extraWidth} />
                </div>
                {nonePage && (
                    <Page
                        initialData={tableBodyData}
                        page={page}
                        setPage={setPage}
                        maxFirstPage={maxFirstPage}
                    />
                )}
            </div>
        </div>
    )
}

function Listheader({ tableHeaderData, Width, extraWidth, tableWidth, setTableWidth }) {
    let ref = useRef()

    useEffect(() => {
        setTableWidth(`${ref?.current?.offsetWidth}` ?? "100%")
    }, [])

    return (
        <div className="tabulator-header" tabindex="0" style={{ paddingRight: "0px", marginLeft: "0px", width: `${Number(Width) > Number(tableWidth) ? Width : tableWidth}px` }}>
            <div className="tabulator-headers tabulator-table" style={{ marginLeft: "0px" }} ref={ref}>
                {
                    tableHeaderData.map(function (a, i) {
                        return (
                            <TableHeaderList key={i} item={a} extraWidth={extraWidth} />
                        )
                    })
                }
            </div>
        </div>
    )
}

function Listbody({ filter_tableBodyData, extraWidth }) {
    if (!filter_tableBodyData.length) {
        return (
            <div
                tabIndex="0"
                style={{
                    minHeight: "calc(100% - 84px)",
                    height: "auto",
                    maxHeight: "calc(100% - 84px)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                }}
            >
                <div
                    style={{
                        color: "#666",
                        margin: "70px 0",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "10px",
                        flexDirection: "column",
                    }}
                >
                    <FileX size={50} />
                    <p>리스트가 없습니다.</p>
                </div>
            </div>
        );
    }
    return (
        <div className="" tabindex="0" style={{ minHeight: " calc(100% - 84px)", height: "auto", maxHeight: "calc(100% - 84px)" }}>
            <div className="tabulator-table" style={{ paddingTop: "0px", paddingBottom: "0px" }}>
                {
                    filter_tableBodyData.map((row, rowIndex) => (
                        <div className="tabulator-row tabulator-selectable tabulator-row-odd" role="row" style={{ paddingLeft: "0px" }}>
                            {
                                row.map((item, itemIndex) => (
                                    <TableBodyList key={`${rowIndex}-${itemIndex}`} item={item} extraWidth={extraWidth} />
                                ))
                            }
                        </div>
                    ))
                }
            </div>
        </div>
    )
}

function TableHeaderList({ item, extraWidth }) {
    let wid = item?.width?.split('px')
    return (
        <div className="tabulator-col tabulator-sortable" role="columnheader" aria-sort="none" style={{ minWidth: `${Number(wid[0]) + extraWidth}px` ?? "100%", width: `${Number(wid[0]) + extraWidth}px` ?? "100%" }}>
            <div className="tabulator-col-content">
                <div className="tabulator-col-title-holder">
                    <div className="tabulator-col-title" style={{ textAlign: item?.textAlign ?? "center" }}>{item.text}</div>
                </div>
            </div>
        </div>
    )
}

function TableBodyList({ item, extraWidth }) {
    let wid = item?.width?.split('px')
    return (
        <div className="tabulator-cell table-overflow-hidden" role="gridcell" style={{ width: `${Number(wid[0]) + extraWidth}px` ?? "100%", textAlign: item?.textAlign ?? "center", display: "inline-flex", alignItems: "flex-start", justifyContent: item.textAlign == "left" ? "flex-start" : item.textAlign == "center" ? "center" : item.textAlign == "right" ? "flex-end" : "center" }}>
            {item.text}
        </div>
    )
}

export default List;